type TimedBooking = { status: string; startsAt?: string; endsAt?: string };

export function isUpcomingStudentBooking(booking: TimedBooking, now: number) {
  return booking.status === 'BOOKED' && Boolean(booking.startsAt) && Date.parse(booking.startsAt!) > now;
}

export function studentBookingTimeLabel(booking: TimedBooking, now: number) {
  if (booking.status !== 'BOOKED' || !booking.startsAt || Date.parse(booking.startsAt) > now) return null;
  return booking.endsAt && Date.parse(booking.endsAt) > now ? '上課中' : '待核銷';
}

export function studentBookingDateParts(startsAt: string, timezone: string) {
  const date = new Date(startsAt);
  return {
    date: date.toLocaleDateString('zh-TW', { timeZone: timezone, month: '2-digit', day: '2-digit' }),
    weekday: date.toLocaleDateString('zh-TW', { timeZone: timezone, weekday: 'short' }),
  };
}

/** 依商店時區取得課表日期，無效時間不帶入篩選。 */
export function studentBookingDateKey(startsAt: string | undefined, timezone: string) {
  if (!startsAt || !Number.isFinite(Date.parse(startsAt))) return '';
  return new Intl.DateTimeFormat('en-CA', { timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(startsAt));
}

export function validStudentCalendarDate(value: string | null) {
  if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return '';
  const parsed = new Date(`${value}T00:00:00Z`);
  return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value ? value : '';
}
